import React, { useState, useEffect, useRef } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import { toast } from "react-toastify";
import {
  BoxContainer,
  Underline,
  BoxTitle,
  BoxHead,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import { useDispatch, useSelector } from "react-redux";
import AddPropertyPage from "../../Components/AddProperty/AddPropertyPage";
import SummaryCards from "../../Components/Properties/SummaryCard";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import { Form, Formik } from "formik";
import DeleteProperty from "../../Components/Properties/DeleteProperty";
import EditPropertyName from "../../Components/Properties/EditPropertyName";
import AddLocationModel from "../../Components/Properties/AddLocationModel";
import Table from "../../Components/Properties/Table";
import { useNavigate } from "react-router-dom";
import EditFineModal from "../../Components/Properties/EditFineModal";
import FilterModal from "../../Components/Properties/FilterModal";
import EditLandlordLeaseDetails from "../../Components/Properties/Lease/EditLandlordLeaseDetails";
import SearchFilterBox from "../../Components/SearchFilterBox";
import { IoFilter } from "react-icons/io5";
import { MdClose } from "react-icons/md";
import SideModal from "../../Components/SideModal";
import ViewLeaseDetails from "../../Components/Properties/Lease/ViewLeaseDetails";
import SelectUtilityBill from "../../Components/Properties/UtilityBills/SelectUtilityBill";
import AddLandlordLeaseDetailsNew from "../../Components/Properties/Lease/AddLandlordLeaseDetailsNew";
import { useEditLandlordLease, useUploadLandlordDocument } from "../../utilities/usePropertyLeaseHooks";
import LocationsFilterDropdown from "../../Components/LocationsFilterDropdown";
import { Select_Property } from "../../Redux/actions";
import SelectLeaseFlat from "../../Components/Properties/Lease/SelectLeaseFlat";

const PropertyList = ({ }) => {
  const dispatch = useDispatch();
  const searchOptions = [{ label: "Name", value: 1 }];
  const user = useSelector((state) => state.UserReducer.user);
  const navigate = useNavigate();
  const [selectedData, setSelectedData] = useState("");
  const [leaseData, setLeaseData] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [filter, setFilter] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [summaryData, setSummaryData] = useState();
  const [apiData, setApiData] = useState();
  const [isAddProperty, setIsAddProperty] = useState(false);
  const [isDeleteProperty, setIsDeleteProperty] = useState(false);
  const [editNameModel, setEditNameModel] = useState(false);
  const [locationModel, setLocationModel] = useState(false);
  const [leaseModel, setLeaseModel] = useState(false);
  const [showAddleaseModel, setShowAddLeaseModel] = useState(false);
  const [showEditLeaseModel, setShowEditLeaseModel] = useState(false);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [editFineModel, setEditFineModel] = useState(false);
  const [isUtilityBills, setIsUtilityBills] = useState(false);
  const [isSelectLeaseFlat, setIsSelectLeaseFlat] = useState(false);
  const [step, setStep] = useState(1);
  const btnRef = useRef(null);
  const [showViewLeaseModel, setShowViewLeaseModel] = useState(false);
  const properties = useSelector((state) => state.PropertyReducer.property);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const locations = useSelector((state) => state.LocationsReducer.locations);
  const location = useSelector(
    (state) => state.SelectLocationReducer.selectLocation
  );

  const [selectedProperty, setSelectedProperty] = useState(property);
  const defaultLocations = {
    id: 0,
    name: "All Locations",
    clientId: 0,
  };
  const [selectedLocation, setSelectedLocation] = useState(location);
  const [selectedFlatForLease, setSelectedFlatForLease] = useState(null);
  const [activeFilter, setActiveFilter] = useState({
    value: "",
    label: "",
    title: "",
  });
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [electricityModalOpen, setElectricityModalOpen] = useState(false);

  const query = `&pageNum=1&searchVal=${searchQuery}&filter=${filter}&locationId=${selectedLocation?.id}`;
  const selectProperty = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const propId = selectProperty.id;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/property/list?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.data === false) error = true;
    else {
      setApiData(res?.data);
      setSummaryData(res?.summary);
      setIsFocused(true);
    }
  };

  const getError = (res) => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  const isFirstRender = useRef(true);

  useEffect(() => {
    // First render → always call API
    if (isFirstRender.current) {
      isFirstRender.current = false;
      getListMutate();
      return;
    }

    // Subsequent renders → only when location changes
    if (selectedLocation) {
      sessionStorage.removeItem("properties_page_index");
      getListMutate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocation?.id, searchQuery]);


  //------- Activate Property -------
  const ActivateFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/property/status/activate `,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const onActivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onActivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
    getListMutate();
  };

  const { isLoading: activateLoading, mutate: activateMutate } = useMutation(
    ActivateFunction,
    {
      onSuccess: onActivateSuccess,
      onError: onActivateError,
    }
  );

  //------- Deactivate Property -------
  const DeactivateFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/property/status/deactivate  `,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const onDeactivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onDeactivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
    getListMutate();
  };

  const { isLoading: deactivateLoading, mutate: deactivateMutate } =
    useMutation(DeactivateFunction, {
      onSuccess: onDeactivateSuccess,
      onError: onDeactivateError,
    });

  const onSummaryBoxClick = (data) => {
    sessionStorage.removeItem("properties_page_index");
    setActiveFilter({ value: "", label: "", title: "" });
    setIsFilterOpen(false);
    setFilter(data);
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  };

  //------- Delete Property -------
  const deletePropertyFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/property/delete`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const deletePropertySuccess = (data) => {
    setIsDeleteProperty(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const deletePropertyError = (data) => {
    setIsDeleteProperty(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deletePropertyLoading, mutate: deletePropertyMutate } =
    useMutation(deletePropertyFunction, {
      onSuccess: deletePropertySuccess,
      onError: deletePropertyError,
    });

  //------- Edit Property Name -------
  const editNameFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/property/renting/rules/edit`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const editNameSuccess = (data) => {
    setEditNameModel(false);
    // setIsDataLoading(true);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const editNameError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editNameLoading, mutate: editNameMutate } = useMutation(
    editNameFunction,
    {
      onSuccess: editNameSuccess,
      onError: editNameError,
    }
  );

  const handleEditPropertyModalClose = () => {
    setEditNameModel(false);
  };
  //------- Add Latitude and Longitude -------
  const addLocationFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/property/update/longitude/latitude`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const addLocationSuccess = (data) => {
    setLocationModel(false);
    // setIsDataLoading(true);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const addLocationError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addLocationLoading, mutate: addLocationMutate } =
    useMutation(addLocationFunction, {
      onSuccess: addLocationSuccess,
      onError: addLocationError,
    });

  //------- Check Landlord/Lease details exist -------

  const fetchLandlordLeaseDetailsFunction = async ({ propId, flatId }) => {
    const url = flatId
      ? `${Config.apiUrl}/property/lease/details?propId=${propId}&flatId=${flatId}`
      : `${Config.apiUrl}/property/lease/details?propId=${propId}`;
    const response = await axios.get(
      url,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getLandlordLeaseDetailsSuccess = (res) => {
    // setIsDataLoading(false);
    if (res.data === false) error = true;
    else {
      if (res?.data?.leaseDetails) {
        setLeaseData(res?.data);
        setShowViewLeaseModel(true);
        // setIsSelectLeaseFlat(false);
      } else {
        setLeaseData(res?.data);
        setShowAddLeaseModel(true);
        // setIsSelectLeaseFlat(false);
      }
    }
  };

  const getLandlordLeaseDetailsError = (res) => { };

  const {
    isLoading: isLandlordLeaseDetailsLoading,
    mutate: mutateFetchLandlordLeaseDetailsFunction,
    error: errorLandlordLeaseDetails,
    data: dummyData,
    isRefetching: isLandlordLeaseDetailsRefetching,
  } = useMutation(fetchLandlordLeaseDetailsFunction, {
    onSuccess: getLandlordLeaseDetailsSuccess,
    onError: getLandlordLeaseDetailsError,
  });

  //------- Add Landlord details -------
  const addLandlordFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/property/add/lease`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const addLandlordSuccess = (data) => {
    setShowAddLeaseModel(false);
    setIsSelectLeaseFlat(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const addLandlordError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addLandlordLoading, mutate: addLandlordMutate } =
    useMutation(addLandlordFunction, {
      onSuccess: addLandlordSuccess,
      onError: addLandlordError,
    });

  const {
    mutate: editLandlordMutate,
    isLoading: editLandlordLoading,
  } = useEditLandlordLease({
    token: user.token,
    onSuccessCallback: (data) => {
      setShowEditLeaseModel(false);
      handleClose();
      getListMutate();
      toast.success(data?.msg || "Success");
    },
    onErrorCallback: (error) => {
      toast.error(error?.response?.data?.msg || "An error occurred");
    },
  });

  const {
    mutate: addDocumentMutate,
    isLoading: addDocumentLoading,
    data: documentData,
  } = useUploadLandlordDocument({
    token: user.token,
    onSuccessCallback: (res) => {
      if (res?.isSuccess === true) {
        toast.success(res?.msg || "Success");
        setShowUploadForm(false);
        setShowViewLeaseModel(false);
        setIsSelectLeaseFlat(false);
      } else {
        toast.error(res?.data?.msg || "An error occurred");
      }
    },
    onErrorCallback: (error) => {
      toast.error(
        error?.response?.data?.msg || "An error occurred"
      );
    },
  });


  const handleClose = () => {
    setLeaseModel(false);
    setShowUploadForm(false);
    setShowViewLeaseModel(false);
    setIsSelectLeaseFlat(false)
  };

  //------- Edit Fine Details -------
  const editFineDetailsFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/property/update/fine/details`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const editFineDetailsSuccess = (data) => {
    setEditFineModel(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const editFineDetailsError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editFineDetailsLoading, mutate: editFineDetailsMutate } =
    useMutation(editFineDetailsFunction, {
      onSuccess: editFineDetailsSuccess,
      onError: editFineDetailsError,
    });

  const handleFineClose = () => {
    setEditFineModel(false);
  };

  const handleFilterClose = () => {
    setIsFilterOpen(false);
  };

  const handleFilterChange = (values) => {
    setSelectedLocation(defaultLocations);
    setSelectedId(null);
    setFilter("");
    setActiveFilter({ value: "", label: "", title: "" });
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    sessionStorage.removeItem("properties_page_index");
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 100);

    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const handleClearFilters = () => {
    setSelectedId(null);
    setFilter("");
    setActiveFilter({ value: "", label: "", title: "" });
    setIsFilterOpen(false);
    setFilterType("");
    setSearchQuery("");
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 100);

    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const clearFilter = () => {
    setSelectedId(null);
    setFilter("");
    setActiveFilter({ value: "", label: "", title: "" });
    setIsFilterOpen(false);
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  };

  const onApplyFilter = (value, label, title) => {
    setSelectedId(null);
    setFilterType("");
    setSearchQuery("");
    setFilter(value);
    setActiveFilter({ value, label, title });
    setIsFilterOpen(false);
    sessionStorage.removeItem("properties_page_index");
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  };

  const handleCloseLeaseViewModal = () => {
    setShowViewLeaseModel(false);
    setShowUploadForm(false);
  };
  const handleCloseLeaseSelectModal = () => {
    setIsSelectLeaseFlat(false);
  };
  const handleCloseUtilityBillModal = () => {
    setIsUtilityBills(false);
    setElectricityModalOpen(false);
  };

  //------- Add Utility bill Model -------
  const AddUtilityBillFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/extra-charges/add/bill`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const addUtilityBillSuccess = (data) => {
    setIsUtilityBills(false);
    toast.success(data?.data?.msg || "Success");
  };

  const addUtilityyBillError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addBillLoading, mutate: addBillMutate } =
    useMutation(AddUtilityBillFunction, {
      onSuccess: addUtilityBillSuccess,
      onError: addUtilityyBillError,
    });
  //------- Add electricity bill Model -------
  const AddElectricityBillFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/electricity/add`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const addElectricityBillSuccess = (data) => {
    setElectricityModalOpen(false);
    setIsUtilityBills(false);
    // getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const addElectricityBillError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addElectricityBillLoading, mutate: addElectricityBillMutate } =
    useMutation(AddElectricityBillFunction, {
      onSuccess: addElectricityBillSuccess,
      onError: addElectricityBillError,
    });

  const handleLocationSelect = (location) => {
    dispatch(Select_Property({ id: 0, name: "All Properties", type: 0, gId: "KIPINN" }));
    setSelectedLocation(location);
    setSelectedProperty({ id: 0, name: "All Properties", type: 0, gId: "KIPINN" })
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Properties
            <Underline />
          </BoxTitle>
          {user.role !== Config.STAFF_ROLES.SALES_HEAD &&
            <Filters setIsAddProperty={setIsAddProperty} />}
        </BoxHead>

        {(isLoading || isRefetching) && !isFocused && (
          <SummarySkeletonLoading count={4} />
        )}
        {isFocused && summaryData && (
          <SummaryCards summaryData={summaryData} onClick={onSummaryBoxClick} setSelectedId={setSelectedId} selectedId={selectedId} />
        )}

        <SideModal
          isOpen={isAddProperty}
          onClose={() => setIsAddProperty(false)}
        >
          <AddPropertyPage
            setIsAddProperty={setIsAddProperty}
            isAddProperty={isAddProperty}
            getListMutate={getListMutate}
            step={step}
            setStep={setStep}
            selectedData={selectedData}
            user={user}
          />
        </SideModal>

        <SideModal
          isOpen={locationModel}
          onClose={() => setLocationModel(false)}
        >
          <AddLocationModel
            setLocationModel={setLocationModel}
            locationModel={locationModel}
            addLocationLoading={addLocationLoading}
            addLocationMutate={addLocationMutate}
            selectedData={selectedData}
          />
        </SideModal>

        {isDeleteProperty && (
          <DeleteProperty
            setIsDeleteProperty={setIsDeleteProperty}
            isDeleteProperty={isDeleteProperty}
            deletePropertyLoading={deletePropertyLoading}
            deletePropertyMutate={deletePropertyMutate}
            selectedData={selectedData}
          />
        )}

        <SideModal
          isOpen={editNameModel}
          onClose={() => setEditNameModel(false)}
        >
          <EditPropertyName
            setEditNameModel={setEditNameModel}
            editNameLoading={editNameLoading}
            editNameMutate={editNameMutate}
            selectedData={selectedData}
            handleClose={handleEditPropertyModalClose}
          />
        </SideModal>

        <SideModal
          isOpen={editFineModel}
          onClose={() => setEditFineModel(false)}
        >
          <EditFineModal
            setEditFineModel={setEditFineModel}
            editFineDetailsLoading={editFineDetailsLoading}
            editFineDetailsMutate={editFineDetailsMutate}
            selectedData={selectedData}
            handleClose={handleFineClose}
          />
        </SideModal>

        <SideModal
          isOpen={showAddleaseModel}
          onClose={() => setShowAddLeaseModel(false)}
          level="high"
          width="1/3"
        >
          <AddLandlordLeaseDetailsNew
            setLeaseModel={setLeaseModel}
            handleClose={setShowAddLeaseModel}
            addLandlordLoading={addLandlordLoading}
            addLandlordMutate={addLandlordMutate}
            propId={propId}
            selectedData={selectedData}
            leaseData={leaseData}
            selectedFlat={selectedFlatForLease}
          // setShowAddLeaseModel={setShowAddLeaseModel}
          />
          {/* <LandlordLeaseForm
            setLeaseModel={setLeaseModel}
            setLeaseData={setLeaseData}
            leaseModel={leaseModel}
            handleClose={handleClose}
            addLandlordLoading={addLandlordLoading}
            addLandlordMutate={addLandlordMutate}
            selectedData={selectedData}
            getListMutate={getListMutate}
            setShowUploadForm={setShowUploadForm}
            showUploadForm={showUploadForm}
            addDocumentLoading={addDocumentLoading}
            addDocumentMutate={addDocumentMutate}
            documentData={documentData}
            setShowEditLeaseModel={setShowEditLeaseModel}
          /> */}
        </SideModal>

        <SideModal
          isOpen={showViewLeaseModel}
          onClose={handleCloseLeaseViewModal}
          level="high"
          width="1/3"
        >
          <ViewLeaseDetails
            leaseData={leaseData}
            handleClose={handleCloseLeaseViewModal}
            selectedData={selectedData}
            setShowUploadForm={setShowUploadForm}
            showUploadForm={showUploadForm}
            addDocumentLoading={addDocumentLoading}
            addDocumentMutate={addDocumentMutate}
            documentData={documentData}
            setShowEditLeaseModel={setShowEditLeaseModel}
            fromPage={"Property-list"}
          />
        </SideModal>

        <SideModal
          isOpen={isSelectLeaseFlat}
          // onClose={handleCloseLeaseSelectModal}
          onClose={() => {
            setIsSelectLeaseFlat(false);
            setSelectedFlatForLease(null);
          }}
          level="base"
        >
          <SelectLeaseFlat
            handleClose={handleCloseLeaseSelectModal}
            selectedData={selectedData}
            mutateFetchLandlordLeaseDetailsFunction={
              mutateFetchLandlordLeaseDetailsFunction
            }
            isLandlordLeaseDetailsLoading={isLandlordLeaseDetailsLoading}
            setSelectedFlatForLease={setSelectedFlatForLease}  // Pass this prop
          />
        </SideModal>

        <SideModal
          isOpen={isUtilityBills}
          onClose={handleCloseUtilityBillModal}
        >
          <SelectUtilityBill
            setIsUtilityBill={setIsUtilityBills}
            handleClose={handleCloseUtilityBillModal}
            selectedData={selectedData}
            addBillLoading={addBillLoading}
            addBillMutate={addBillMutate}
            addElectricityBillLoading={addElectricityBillLoading}
            addElectricityBillMutate={addElectricityBillMutate}
            setElectricityModalOpen={setElectricityModalOpen}
            electricityModalOpen={electricityModalOpen}
          />
        </SideModal>

        <SideModal
          isOpen={showEditLeaseModel}
          onClose={() => setShowEditLeaseModel(false)}
          width="1/3"
          level="highest"
        >
          <EditLandlordLeaseDetails
            //setLeaseModel={setShowEditLeaseModel}
            leaseModel={leaseModel}
            handleClose={() => setShowEditLeaseModel(false)}
            editLandlordLoading={editLandlordLoading}
            editLandlordMutate={editLandlordMutate}
            selectedData={selectedData}
            getListMutate={getListMutate}
            leaseData={leaseData?.leaseDetails}
          />
        </SideModal>

        <SideModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
          <FilterModal
            setIsFilterOpen={setIsFilterOpen}
            onApplyFilter={onApplyFilter}
            selectedData={selectedData}
            handleClose={handleFilterClose}
          />
        </SideModal>

        <FilterTableWrapper>
          <FilterWrapper>
            <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
              <SearchFilterBox
                options={searchOptions}
                handleFilterChange={handleFilterChange}
                handleClearFilters={handleClearFilters}
              />
            </div>

            <div className="flex gap-2 justify-end items-center pr-4">

              <LocationsFilterDropdown
                locations={locations}
                selectedLocation={selectedLocation}
                onSelect={handleLocationSelect}
                placeholder="All Locations"
                className="w-full md:w-[200px]"
              />

              {activeFilter.value && !isLoading ? (
                <div className="hidden md:inline-flex items-center gap-2 rounded-md 
                bg-slate-100 px-3 h-9 text-sm text-slate-600">
                  <div className="flex items-center gap-2">
                    <span className="text-slate-600 text-sm">
                      {activeFilter.title ? `${activeFilter.title} : ` : ""}{" "}
                      {activeFilter.label}
                    </span>
                    <div className="bg-gray-100 px-2 rounded-lg">
                      <span className="text-sm font-semibold text-slate-800">
                        {data?.data?.total}
                      </span>
                    </div>
                    <button
                      aria-label="Clear filter"
                      className="rounded-full p-1 hover:bg-slate-200 transition"
                      onClick={clearFilter}
                    >
                      <MdClose size={14} />
                    </button>
                  </div>
                </div>
              ) : null}

              <div className="relative">
                {/* {isFocused && data && ( */}
                <FilterBtn
                  ref={btnRef}
                  type="button"
                  title="Property Filter"
                  onClick={() => setIsFilterOpen((v) => !v)}
                >
                  <IoFilter size={14} color="#9CA3AF" />
                </FilterBtn>
                {/* )} */}
              </div>
            </div>
          </FilterWrapper>
          {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                apiData={apiData}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                step={step}
                setStep={setStep}
                setIsAddProperty={setIsAddProperty}
                isAddProperty={isAddProperty}
                activateLoading={activateLoading}
                activateMutate={activateMutate}
                deactivateMutate={deactivateMutate}
                deactivateLoading={deactivateLoading}
                setIsDeleteProperty={setIsDeleteProperty}
                setEditNameModel={setEditNameModel}
                setLocationModel={setLocationModel}
                setIsUtilityBills={setIsUtilityBills}
                //setLeaseModel={setLeaseModel}
                mutateFetchLandlordLeaseDetailsFunction={
                  mutateFetchLandlordLeaseDetailsFunction
                }
                setEditFineModel={setEditFineModel}
                setIsSelectLeaseFlat={setIsSelectLeaseFlat}
              />
            </TableWrapper>
          )}
        </FilterTableWrapper>
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const Filters = ({ setIsAddProperty }) => {
  return (
    <Formik>
      <Form>
        <FilterContainer>
          <AddBtn
            type="button"
            onClick={() => {
              setIsAddProperty(true);
            }}
          >
            {"Add Property"}
          </AddBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;
const FilterBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;

const AddBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110  py-2.5 text-sm`;
const FilterContainer = tw.div`
    grid grid-cols-2 w-full gap-4 md:flex md:space-x-4 items-end mt-0 md:mt-0`;
export default PropertyList;
